let items = document.querySelector(".header__inline-menu").querySelectorAll("details");  
  items.forEach(item => {
    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      item.querySelector("ul").addEventListener("mouseleave", () => {
        item.removeAttribute("open");
      });
    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  });  
  });


document.addEventListener('DOMContentLoaded', function() {
$(".lnd-bton-one").click(function(){   
  $('.landing-step-two').fadeOut(1000, function() {
  $('.landing-step-two').remove();
});  
setTimeout(function(){  
  $('.landing-step-three').show();
  if ($(window).width() > 750) {
    //$(".landing-step-three").animate({width:"100%"},1000);  
  } else {
    //$(".landing-step-three").animate({height:"100%"},1000);   
  }
}, 100)  
 
});

$(".lnd-banner-logo").click(function(){ 
  $('.section-main-page-landing').fadeOut(1000, function() {
  $('.section-main-page-landing').remove();  
   $('body').removeClass("overflow-hidden");   
});     
document.cookie = "loadscreen=loadingscreen; path=/; max-age=" + 7*24*60*60;  
});  
});   


$(document).ready(function() {
  $(".redfull-button").click(function() {   
    $(".full-article").slideDown();
  });

  $(".annous-close").click(function() {   
    $(".announcement-bar-section").remove();
  });  


   $(".photo-layer-img img").hover(
        function() {            
            $(".photo-layer-img img").css("z-index", 0);
            $(this).css("z-index", 1);
        }
    );
  
});


$(document).ready(function() {
    $(".dragimg .photo-layer-img img").draggable();
});


var animatedDivs = document.querySelectorAll('.dragimg');

    // Function to handle the scroll event
    function handleScroll() {
      // Get the current scroll position
      var scrollPosition = window.scrollY;

      // Set a threshold value (adjust as needed)
      var threshold = 600;

      // Loop through each animatedDiv
      animatedDivs.forEach(function (animatedDiv) {
        // Get the top position of the animatedDiv
        var divPosition = animatedDiv.offsetTop;

        // Check if the animatedDiv is in the viewport
        if (scrollPosition > divPosition - threshold ) {
          // If it is, add the visible class
          animatedDiv.classList.add('visible-class');
        } else {
          // If it's not, remove the visible class
          //animatedDiv.classList.remove('visible-class');
        }
      });
    }

    // Attach the handleScroll function to the window's scroll event
    window.onscroll = handleScroll;


$(window).on('load resize scroll', function() {
  $('.awards-main').each(function() {
    var windowTop = $(window).scrollTop();
    var elementTop = $(this).offset().top;
    var leftPosition = windowTop - elementTop;    
      $(this)
        .find('.left-awards-logo')
        .css({ left: leftPosition });

    $(this)
        .find('.right-awards-logo')
        .css({ right: leftPosition });

    if(leftPosition > 0){
      $('.left-awards-logo').css("position", "static");
      $('.right-awards-logo').css("position", "static");
    } else {
      $('.left-awards-logo').css("position", "relative");
      $('.right-awards-logo').css("position", "relative");
    }
    
  });
});

$(document).ready(function(){
$("summary.header__icon.header__icon--menu .icon-hamburger").click(function(){
  $(".menu-drawer .line-border-main").addClass("visible");
});
$("summary.header__icon.header__icon--menu .icon-close").click(function(){
  $(".menu-drawer .line-border-main").removeClass("visible");
});  
});



$(document).ready(function(){
var targetDiv = $('.line-border-at-top');
var divOffset = targetDiv.offset().top;  
  if(divOffset < 100){
    $(targetDiv).addClass("visible");
  }
});


$(document).ready(function(){
    $(window).on('scroll', function() {
        // Loop through each section
        $('.line-border-main').each(function() {
            var $this = $(this);
            var top = $this.offset().top;
            var bottom = top + $this.height();
            var windowTop = $(window).scrollTop();
            var windowBottom = windowTop + $(window).height();
            
            // Check if the section is within the viewport
            if (bottom > windowTop && top < windowBottom) {
                $this.addClass('visible');
            } else {
                $this.removeClass('visible');
            }
        });
    });
});